import { useState } from 'react';
import Translator from '../../../classes/Translator/Translator';
import FileUploadService from './fileUpload.service';
import CustomError from '../../../classes/CustomError/CustomError';

const FileUploadLogic = (props) => {
  const { translator } = Translator();
  const [isUploading, setIsUploading] = useState(false);
  const fileUploadService = FileUploadService();

  const handleFileUpload = async (file) => {
    if (!file) {
      return { success: false, error: 'No file selected' };
    }

    setIsUploading(true);

    try {
      const documentData = {
        file,
        id: props.id,
        type: props.type,
        description: props.description,
      };

      const result = await fileUploadService.uploadFile(documentData);

      const has_error = result instanceof CustomError;
      
      if (has_error) {
        return has_error;
      } else {
        // Llamar al callback de éxito si existe
        if (props.onUploadSuccess) {
          props.onUploadSuccess(result);
        }
        return { success: true, data: result };
      }
    } catch (error) {
      // Llamar al callback de error si existe
      if (props.onUploadError) {
        props.onUploadError(error);
      }
      return { success: false, error };
    } finally {
      setIsUploading(false);
    }
  };

  return {
    translator,
    isUploading,
    handleFileUpload,
  };
};

export default FileUploadLogic;